export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40dba66503bfeec4d0456e9df91073f8a8f1a89a04&name=revalidateCommunity!'